import * as React from "react";

interface ReportIconProps {
  className?: string;
  color?: string;
  onClick?: () => void;
}

export default function ReportIcon({
  className,
  color,
  onClick,
}: ReportIconProps) {
  return (
    <div className={className} onClick={onClick}>
      <svg
        width="33"
        height="30"
        viewBox="0 0 33 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.01238 9.01919H6.01424L6.01444 15.0223H3.0164V21.035H6.01444V15.0319H9.01248L9.01238 9.01919ZM20.9894 3.00636L20.9893 6.01273V9.01919H23.9874V3.00636H20.9894V0H11.9953V3.00636H8.99721V9.01909H11.9953V3.00636H20.9894ZM29.9653 30H2.99794V26.9935H29.9653V30ZM2.99804 26.9934H0V20.9807H2.99804V26.9934ZM33 26.9934H30.002V20.9807H27.0039L26.9856 15.0319H23.9875V9.01919H26.9856V15.0223H29.9836L30.002 20.9807H33V26.9934ZM14.9749 8.95536H17.973V17.9744H14.9749V8.95536ZM17.973 23.9872H14.9749V20.9808H17.973V23.9872Z"
          fill={color || "#FF0000"}
        />
      </svg>
    </div>
  );
}
